import {FC, useContext, useEffect, useState} from "react";
import { PesticideMapSidebarWrapper } from "./styles";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { AddLarge, FilterIcon } from "shared/ui/icons";
import {useReactify} from "shared/api";
import {ConfigContext} from "../../../app/App.tsx";

type PesticideMapSidebarProps = {
  isMobile?: boolean;
  isFiltersOpen?: boolean;
  onFiltersClcik?: () => void;
  onCreateClcik?: () => void;
}

export const PesticideMapSidebar: FC<PesticideMapSidebarProps> = ({
  isMobile,
  isFiltersOpen,
  onFiltersClcik,
  onCreateClcik,
}) => {
  const {VITE_YANDEX_TOKEN} = useContext(ConfigContext);
  const reactify = useReactify(VITE_YANDEX_TOKEN)
  
  if (!reactify) return null;
  
  return (
    <PesticideMapSidebarWrapper $isFiltersOpen={isFiltersOpen}>
      {onFiltersClcik && 
      <Button 
        iconPrefix={<FilterIcon />}
        size={isMobile ? 'm' : "l"}
        onClick={onFiltersClcik}
      />
      }

      <reactify.YMapControls
        position="right"
        orientation="vertical"
      >
        <reactify.YMapZoomControl />
        <reactify.YMapGeolocationControl />
      </reactify.YMapControls>

      {onCreateClcik && 
      <Button 
        label="Добавить метку"
        iconPrefix={<AddLarge />}
        size={isMobile ? 'm' : "l"}
        onClick={onCreateClcik}
      />
      }
    </PesticideMapSidebarWrapper>
  )
}